import states from "./states"
import {
  GI_UPDATE_STATE,
  GI_MORE_INTENTS_LOADED,
  GI_INTENT_CREATED,
  GI_INTENT_UPDATED,
  GI_INTENT_DELETED,
} from "./actiontypes"
import { MODULE_CONFIG } from "../../config/setup"

const genai_intent_details = (state = states.genai_intent_details, action) => {
  switch (action.type) {
    case GI_UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case GI_MORE_INTENTS_LOADED:
      return {
        ...state,
        intents: [...state.intents, ...action.payload],
        gi_has_more:
          action.payload.length ===
          MODULE_CONFIG.GENAI_CLASSIFIER.GI_RECORDS_PER_PAGE_DATA,
      }

    case GI_INTENT_CREATED:
      return {
        ...state,
        intents: [action.payload, ...state.intents],
      }

    case GI_INTENT_UPDATED: {
      let index = -1
      index = state.intents.findIndex(intent => intent.id === action.payload.id)
      if (index !== -1)
        return {
          ...state,
          intents: [
            ...state.intents.slice(0, index),
            {
              ...state.intents[index],
              ...action.payload,
            },
            ...state.intents.slice(index + 1),
          ],
        }
      return state
    }

    case GI_INTENT_DELETED: {
      let index = -1
      index = state.intents.findIndex(intent => intent.id === action.payload)
      if (index !== -1)
        return {
          ...state,
          intents: [
            ...state.intents.slice(0, index),
            ...state.intents.slice(index + 1),
          ],
        }
      return state
    }

    default:
      return state
  }
}

export default genai_intent_details
